module.exports = __webpack_public_path__ + "static/media/abhi-bio.d1e1b09e.jpg";